export { default } from "./CopyWidget";
